import { render, staticRenderFns } from "./TaxVat.vue?vue&type=template&id=617190c4&scoped=true&"
import script from "./TaxVat.vue?vue&type=script&lang=js&"
export * from "./TaxVat.vue?vue&type=script&lang=js&"
import style0 from "./TaxVat.vue?vue&type=style&index=0&id=617190c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617190c4",
  null
  
)

export default component.exports